<template>
  <div class="over">
    本平台于2023年9月28日晚22点起 - 2023年10月7日早上9点止关闭（10月7日早上9点开启）
    请耐心等待。。。
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
.over{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .24rem;
    box-sizing: border-box;
    padding: .3rem;
    padding-top: 1rem;
}
</style>